/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import './dep-eba62589.mjs';
import { a as _createCompounder } from './dep-31dc9d09.mjs';

var createCompounder = _createCompounder;

/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */
var kebabCase = createCompounder(function (result, word, index) {
  return result + (index ? '-' : '') + word.toLowerCase();
});
var kebabCase_1 = kebabCase;

export { kebabCase_1 as k };
//# sourceMappingURL=dep-b9d74a58.mjs.map
